import { useMatch } from "react-router";

import { ASSISTANT_PAGE_ROUTE } from "../constants";

const useIsAssistantPageMode = () => !!useMatch(ASSISTANT_PAGE_ROUTE);

export default useIsAssistantPageMode;
